import React, { useState } from "react";
import {
  collection,
  query,
  where,
  getDocs,
  deleteDoc,
} from "firebase/firestore";
import { db } from "../../firebaseConfig";
import { useAuth } from "../../context/AuthContext";

interface UnregisterButtonProps {
  eventId: string;
  onUnregister: () => void;
}

const UnregisterButton: React.FC<UnregisterButtonProps> = ({
  eventId,
  onUnregister,
}) => {
  const [isUnregistering, setIsUnregistering] = useState(false);
  const { user } = useAuth();

  const handleUnregister = async () => {
    if (!user || !eventId) return;

    if (window.confirm("Are you sure you want to cancel your registration?")) {
      setIsUnregistering(true);
      try {
        const q = query(
          collection(db, `events/${eventId}/registrations`),
          where("userId", "==", user.uid)
        );
        const querySnapshot = await getDocs(q);
        if (!querySnapshot.empty) {
          await deleteDoc(querySnapshot.docs[0].ref);
          alert("Your registration has been cancelled.");
          onUnregister();
        }
      } catch (error) {
        console.error("Error removing registration: ", error);
        alert(
          "An error occurred while cancelling your registration. Please try again."
        );
      } finally {
        setIsUnregistering(false);
      }
    }
  };

  return (
    <button
      onClick={handleUnregister}
      disabled={isUnregistering}
      className="w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:opacity-50"
    >
      {isUnregistering ? "Cancelling..." : "Cancel Registration"}
    </button>
  );
};

export default UnregisterButton;
